var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('menu-item',{attrs:{"label":_vm.$t('fits_images'),"keybind":"shift+I"},model:{value:(_vm.module.showManager),callback:function ($$v) {_vm.$set(_vm.module, "showManager", $$v)},expression:"module.showManager"}})}
var staticRenderFns = []

export { render, staticRenderFns }